module.exports = __webpack_public_path__ + "a9585baa342783d6db896e625b8206f3.svg";